import React from 'react';
import PropTypes from 'prop-types';
import {PreciseStepper} from './PreciseStepper';
import {VagueStepper} from './VagueStepper';

import style from './style.module.scss';

export function Stepper(props) {
  const renderStepper = () => {
    if(Object.keys(props.mobileControls).length === 0){
      return (
        <VagueStepper
          currentValue={props.currentValue}
          onChange={props.onChange}
          min={props.min}
          max={props.max}
          step={props.step}
          altTextData={props.altTextData}
          ariaInterval={props.ariaInterval}
          keyboardStep={props.keyboardStep}
        />
      );
    }
    else if(props.mobileControls.preset === "Precise"){
      return (
        <PreciseStepper
          currentValue={props.currentValue}
          onChange={props.onChange}
          min={props.min}
          max={props.max}
          step={props.step}
          unit={props.mobileControls.unit}
        />
      );
    }
    else if(props.mobileControls.preset === "Vague"){
      return (
        <VagueStepper
          currentValue={props.currentValue}
          onChange={props.onChange}
          min={props.min}
          max={props.max}
          step={props.step}
          altTextData={props.altTextData}
          ariaInterval={props.ariaInterval}
          keyboardStep={props.keyboardStep}
          mobileControls={props.mobileControls}
        />
      );
    }
    else return;
  };

  return <div className={style.stepper}>{renderStepper()}</div>;
}

Stepper.propTypes = {
  /**
   * string to be displayed in precise stepper
   */
  currentValue: PropTypes.string,
  /**
   * bool specifies if vague value provided
   */
  valueType: PropTypes.oneOf(['precise', 'vague']),
  ...PreciseStepper.propTypes,
  ...VagueStepper.propTypes,
};
